import { useEffect } from 'react';

import { datadogRum, DefaultPrivacyLevel } from '@datadog/browser-rum';
import { getAppConfig } from 'app/getConfig';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FeatureFlags } from 'config/featureFlags';

export const useInitializeRUM = () => {
  const isRUMEnabled = useFeatureIsOn(FeatureFlags.DATADOG_RUM);
  const {
    DATADOG_ADMIN_UI_RUM_APPLICATION_ID,
    DATADOG_ADMIN_UI_CLIENT_TOKEN,
    DATADOG_ADMIN_UI_RUM_DEFAULT_PRIVACY_LEVEL,
    DATADOG_ADMIN_UI_RUM_SESSION_REPLAY_SAMPLE_RATE,
    DATADOG_ADMIN_UI_RUM_SESSION_SAMPLE_RATE,
    NODE_ENV,
    ADMIN_API_CLIENT_URL,
    AUTH_API_CLIENT_URL,
    REPORT_API_CLIENT_URL,
  } = getAppConfig();

  const isAllowedToInit =
    isRUMEnabled && DATADOG_ADMIN_UI_RUM_APPLICATION_ID && DATADOG_ADMIN_UI_CLIENT_TOKEN;

  useEffect(() => {
    if (isAllowedToInit) {
      datadogRum.init({
        applicationId: DATADOG_ADMIN_UI_RUM_APPLICATION_ID,
        clientToken: DATADOG_ADMIN_UI_CLIENT_TOKEN,
        site: 'datadoghq.eu',
        service: 'admin-ui',
        env: NODE_ENV,
        defaultPrivacyLevel: DATADOG_ADMIN_UI_RUM_DEFAULT_PRIVACY_LEVEL as DefaultPrivacyLevel,
        sessionReplaySampleRate: parseInt(DATADOG_ADMIN_UI_RUM_SESSION_REPLAY_SAMPLE_RATE),
        sessionSampleRate: parseInt(DATADOG_ADMIN_UI_RUM_SESSION_SAMPLE_RATE),
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        allowedTracingUrls: [ADMIN_API_CLIENT_URL, AUTH_API_CLIENT_URL, REPORT_API_CLIENT_URL],
        enableExperimentalFeatures: ['feature_flags'],
      });

      datadogRum.startSessionReplayRecording();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
